/**
 * Input — labeled form input.
 * Just a thin, accessible wrapper. No fancy validation hooks — keep simple.
 */
export default function Input({
  label,
  id,
  type = 'text',
  error = null,
  className = '',
  ...props
}) {
  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input
        id={id}
        type={type}
        className={`w-full px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-ghasc-navy focus:border-transparent ${
          error ? 'border-ghasc-danger' : 'border-gray-300'
        }`}
        {...props}
      />
      {error && <p className="mt-1 text-sm text-ghasc-danger">{error}</p>}
    </div>
  )
}
